import { Dispatch, SetStateAction } from 'react';

import {
    Documents,
    GetDocumentUrlInput,
    ListDocumentsInput,
    ListDocumentsOutput
} from '@amzn/coral_com-amazon-musicpaperrecordkeeperservice';

import { isNil } from 'lodash';
import { RECORD_KEEPER_TENANT_ID, recordKeeperClient } from 'src/api/recordKeeper/RecordKeeperClient';

/**
 * Generate a temporary link to the document contents
 * @param documentId The ID of the document to generate a link for
 * @param tenantId The ID of the tenant that owns the document
 * @param setLoading A state setter for indicating the link is being generated.
 * @param setErrorMessage A state setter for any errors during link generation.
 */
export function goToDocument(
    documentId: string,
    tenantId: string,
    setLoading: Dispatch<SetStateAction<boolean>>,
    setErrorMessage: Dispatch<SetStateAction<string | undefined>>
): void {
    setLoading(true);
    recordKeeperClient.getDocumentUrl(GetDocumentUrlInput.clone({ documentId, tenantId })).subscribe({
        next: (value) => {
            window.open(value.presignedUrl, '_blank');
            setLoading(false);
        },
        error: (err) => {
            setErrorMessage(JSON.stringify(err));
            setLoading(false);
        }
    });
}

export async function listAllDocuments(
    username: string,
    onFail: Dispatch<SetStateAction<string | undefined>>
): Promise<Documents> {
    const allDocuments: Documents = [];
    let nextToken: string | undefined = undefined;

    do {
        const output: ListDocumentsOutput = await recordKeeperClient
            .listDocuments(
                ListDocumentsInput.clone({
                    tenantId: RECORD_KEEPER_TENANT_ID,
                    continuationToken: nextToken,
                    username
                })
            )
            .toPromise()
            .catch((e) => {
                onFail(JSON.stringify(e));
                return ListDocumentsOutput.clone({ documents: [] });
            });

        nextToken = output.continuationToken;
        allDocuments.push(...output.documents);
    } while (!isNil(nextToken));

    return allDocuments;
}
